import React, { useState, useEffect } from 'react';
import { AdminContext, useGetState, useMount } from '../../hooks';
import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import axios from 'axios';

import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

let formatDate = (date) => {
  let d = date.getDate();
  let suffix = [,'st','nd','rd'][d] ?? 'th';
  return `${d}${suffix} ${date.toLocaleString('en-GB', { month: 'short' })} ${date.getFullYear()}`;
};

let formatTime = (time) => {
    let days = Math.floor(time / (1000 * 60 * 60 * 24));
    let weeks = time % 7;
    days -= weeks * 7;
    return (weeks ? weeks + ' weeks, ' : '') + days + ' days';
}

export default function BoatMap({paths, markers}) {
    if (!paths) return null;

    let n = paths.length-1;
    let point = paths[n][paths[n].length-1];
    
    return (
        <MapContainer
            center={point} 
            zoom={13} 
            style={{ height: "100vh", width: "100%" }}
        >
            <TileLayer
                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
                attribution='&copy; OpenStreetMap contributors'
            />
            {paths.map(points=><Polyline positions={points} color="#2F86CC" />)}
            {markers.map(marker => <Marker position={marker.pos}>
                <Popup>
                    <div>
                        <a
                            href={`https://www.google.com/maps?q=${marker.pos[0]},${marker.pos[1]}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {marker.pos[0].toFixed(5)}, {marker.pos[1].toFixed(5)}
                        </a>
                    </div>
                    <div className="dates">
                        <div>Arrived {formatDate(new Date(marker.stamp[0]))}</div>
                        <div>Stayed for {formatTime(marker.stamp[1]-marker.stamp[0])}</div>
                    </div>
                </Popup>
            </Marker>)}
        </MapContainer>
    );
}